<template>
  <audio @ended="handleEnded" :key="key" v-if="type === 'audio'" ref="videoPlayer"
         class="video-js vjs-big-play-centered"></audio>
  <video @ended="handleEnded" :key="key" v-if="type === 'video'" ref="videoPlayer"
         class="video-js vjs-big-play-centered"></video>
</template>

<script>
import videojs from 'video.js';
import 'video.js/dist/video-js.css';

export default {
  name: "Player",
  props: {
    options: {
      type: Object,
      default() {
        return {};
      }
    },
    type: {
      type: String,
      default() {
        return "audio";
      }
    },
    key: {
      type: String
    }
  },
  data() {
    return {
      player: null
    }
  },
  methods: {
    init(options) {
      this.player = videojs(this.$refs.videoPlayer, options, function onPlayerReady() {
        console.log('new player ready.............');
      })
    },
    destroyPlayer() {
      if (this.player) {
        this.player.dispose();
      }
    },
    handleEnded() {
      this.$emit("ended");
    }
  },
  mounted() {
    this.init(this.options);
  },
  watch: {
    options: {
      handler(newVal) {
        this.init(newVal);
      },
      deep: true
    }
  },
  beforeUnmount() {
    this.destroyPlayer();
  }
}
</script>
